var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.order != null)?_c('section',[(_vm.order.items.length > 0)?_c('CartDisplay',{attrs:{"order":_vm.order,"loading":_vm.loadingOrder}}):_c('CartEmpty')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }